import React from 'react';
import Page from '../../../layout/Page';
import CodeLiability from './CodeLiability';
import SingleUseCodes from './SingleUseCodes';
import { userRoles } from '../../../RoleProtected';
import BundleCodes from './BundleCodes';
import KioskErrorResponses from '../KioskErrorResponses';
import { QuestRoute } from '../../../api/QuestRoutes';
import Button from '../../../forms/Button';
import { codeLookUp } from '../../codes/Codes';

const CodesReport = ({ children, ...props }) => {

    return (
        <Page
            title='Codes'
            controls={<Button onClick={codeLookUp}>Look Up</Button>}
            tabs
        >
            <CodeLiability  tab='Code Liability' roles={userRoles.viewAuditReports} />
            <SingleUseCodes tab='Single Use Codes' roles={userRoles.viewAuditReports}/>
            <BundleCodes tab='Bundle Codes' roles={userRoles.viewAuditReports} />
            <KioskErrorResponses 
                tab='Error Responses' 
                parentPage='CodeReport'
                dataRoute={QuestRoute.reports.kioskErrorResponseLog('code')}
                roles={userRoles.viewUsageReports} 
            />
        </Page >
    );
}

export default CodesReport;
